import { render, staticRenderFns } from "./ReportePagos.vue?vue&type=template&id=c0b113ac&scoped=true"
import script from "./ReportePagos.vue?vue&type=script&lang=js"
export * from "./ReportePagos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0b113ac",
  null
  
)

export default component.exports